import React, { useState } from 'react'
import ReactModal from 'react-modal'
import CreateFormModal from './formBuilderModel/CreateFormModal'
import PreviewModal from './formBuilderModel/PreviewModal'
interface Props {
  formName: any
  formDescription: any
  formImageLink: any
  formJson: any
  templateId: any
}

const FormTemplateCard: React.FC<Props> = ({
  formName,
  formDescription,
  formImageLink,
  formJson,
  templateId
}) => {
  const [isHovered, setIsHovered] = useState<boolean>(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isPreviewModalOpen, setPreviewIsModalOpen] = useState(false)

  const handleMouseEnter = () => {
    setIsHovered(true)
  }

  const handleMouseLeave = () => {
    setIsHovered(false)
  }

  const openModal = () => {
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }

  const openPreviewModal = () => {
    setPreviewIsModalOpen(true)
  }

  const afterOpenPreviewModal = () => {
    // Adjust modal styles if needed
  }

  const closePreviewModal = () => {
    setPreviewIsModalOpen(false)
  }

  const customPreviewModalStyles: ReactModal.Styles = {
    content: {
      top: '55%',
      left: '45%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-60%',
      transform: 'translate(-30%, -60%)',
      height: '80%'
    }
  }

  const imgContainerStyle: React.CSSProperties = {
    position: 'relative',
    width: '100%'
  }

  const overlayStyle: React.CSSProperties = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: isHovered ? 'flex' : 'none',
    justifyContent: 'center',
    alignItems: 'center'
  }

  const imgStyle: React.CSSProperties = {
    width: '100%',
    height: 'auto'
  }

  return (
    <div className='col-md-3'>
      <div className='card mb-3' style={{ height: '100%' }}>
        <div
          className='card-body'
          style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
          }}
        >
          <div
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={imgContainerStyle}
          >
            <img
              style={{ ...imgStyle, height: '250px' }}
              src={formImageLink}
              alt='Product Order Form'
              className='img-fluid mb-3'
            />
            <div style={overlayStyle}>
              <button
                className='btn btn-primary'
                style={{ borderRadius: '50px', height: '40px' }}
                onClick={openPreviewModal}
              >
                <i className='fa fa-eye'></i>Preview
              </button>
            </div>
          </div>
          <h3 className='d-flex card-title text-center mb-8 align-item-start mt-3'>{formName}</h3>
          <button
            className='btn btn-primary d-block mx-auto mb-3'
            type='button'
            style={{ width: '100%' }}
            onClick={openModal}
          >
            Use Template
          </button>
        </div>
      </div>

      <CreateFormModal
        show={isModalOpen}
        closeModal={closeModal}
        setIsModalOpen={setIsModalOpen}
        formJson={formJson}
        templateId={templateId}
      />
      <ReactModal
        isOpen={isPreviewModalOpen}
        onAfterOpen={afterOpenPreviewModal}
        onRequestClose={closePreviewModal}
        style={customPreviewModalStyles}
        contentLabel='Edit User'
      >
        <PreviewModal
          closeModal={closePreviewModal}
          formJson={formJson}
          cardBackground={''}
          cardStyle={''}
        />
      </ReactModal>
    </div>
  )
}

export default FormTemplateCard
